import axios from "../../index";
import api from "./projects.api";

export default {
    // 课程实训接口
    /**
     * 查询课程实训下我的项目列表  @data "pageNum":"1" ;  "pageSize":"10"
     */
    getMyProjectList(data = {}) {
        return axios.post(api.getMyProjectList, data);
    },
    /**
     * 学生查询课程实训下我的项目列表
     */
    getProjectListByStudentId(data = {}) {
        return axios.post(api.getProjectListByStudentId, data);
    },
    /**
     * 创建课程实训
     */
    insertCurriculum(data = {}) {
        return axios.post(api.insertCurriculum, data);
    },
    /**
     * 修改课程实训
     */
    updateCurriculum(data = {}) {
        return axios.post(api.updateCurriculum, data);
    },
    /**
     * 删除课程实训
     */
    deleteCurriculum(data = {}) {
        return axios.post(api.deleteCurriculum, data);
    },
    /**
     * 根据课程id查询课程信息  @data "curriculumId": "课程id" ;
     */
    getCurriculumInfoByCurriculumId(data = {}) {
        return axios.post(api.getCurriculumInfoByCurriculumId, data);
    },
    /**
     * 置顶课程实训  @data "curriculumId": "课程id", "type": 0-精/1-内置 ;
     */
    topCurriculum(data = {}) {
        return axios.post(api.topCurriculum, data);
    },
    /**
     * 复制课程  @data "curriculumId": "课程id", "tenantId": '租户id' ;
     */
    copyCurriculum(data = {}) {
        return axios.post(api.copyCurriculum, data);
    },

    /**
     * 根据课程id查询租户关联信息  @data "curriculumId": "课程id", "tenantName": "租户名称（搜索）";
     */
    getTenantRelationByCurriculumId(data = {}) {
        return axios.post(api.getTenantRelationByCurriculumId, data);
    },
    /**
     * 根据课程id查询租户列表  @data "curriculumId": "课程id", "tenantName": "租户名称（搜索）";
     */
    getTenantByCurriculumId(data = {}) {
        return axios.post(api.getTenantByCurriculumId, data);
    },
    /**
     * 保存课程与租户的关联关系  @data {
        "curriculumId": "课程id",
        "tenantInfos": [
          {
            "introduce": "租户描述",
            "tenantId": "租户id",
            "tenantName": "租户名称",
            "type": 0, //租户类别：10为内置租户，20为普通租户
          }
        ]
      };
     */
    saveCurriculumAndTenant(data = {}) {
        return axios.post(api.saveCurriculumAndTenant, data);
    },
    /**
     * 根据关联id删除租户关联关系  @data "relationId": "关联关系id";
     */
    deleteRelationByRelationId(data = {}) {
        return axios.post(api.deleteRelationByRelationId, data);
    },
    /**
     * 根据关联id批量删除租户关联关系  @data {
       "relationIds": ["关联关系id"]
     };
     */
    batchDeleteRelationByRelationId(data = {}) {
        return axios.post(api.batchDeleteRelationByRelationId, data);
    },

    /**
     * 查看课程关联的用户列表  @data {
       "curriculumId": "课程id",
       "keyword": "模糊搜索字段：包含姓名、账号、联系方式",
     };
     */
    getUserListByCurriculumId(data = {}) {
        return axios.post(api.getUserListByCurriculumId, data);
    },
    /**
     * 查询当前用户所在组织的学生  @data {"keyword": "模糊搜索关键字：姓名",};
     */
    getStudentByCurrentUser(data = {}) {
        return axios.post(api.getStudentByCurrentUser, data);
    },
    /**
     * 课程关联学生  @data { "curriculumId": "课程id", "userIds": [用户id] };
     */
    saveCurriculumAndStudent(data = {}) {
        return axios.post(api.saveCurriculumAndStudent, data);
    },
    /**
     * 单个删除课程关联的用户  @data { "curriculumId": "课程id", "userId": 用户id };
     */
    deleteCurriculumUser(data = {}) {
        return axios.post(api.deleteCurriculumUser, data);
    },
    /**
     * 批量删除课程关联的用户  @data {
        "curriculumId": "课程id",
        "userIds": [ 用户id ]
      };
     */
    batchDeleteCurriculumUser(data = {}) {
        return axios.post(api.batchDeleteCurriculumUser, data);
    },


    // 实训项目接口
    /**
     * 查询实训项目列表数据  @data "curriculumId":"" ;"pageNum":"1" ;  "pageSize":"10"
     */
    getTrainingListByCurriculumId(data = {}) {
        return axios.post(api.getTrainingListByCurriculumId, data);
    },
    /**
     * 查询实训目录列表数据(学生)  @data "curriculumId":"" ;"pageNum":"1" ;  "pageSize":"10"
     */
    getTrainingListByCurriculumIdStu(data = {}) {
        return axios.post(api.getTrainingListByCurriculumIdStu, data);
    },
    /**
     * 根据实训id查询实训信息  @data "trainingId": "实训id" ;
     */
    getTrainingByTrainingId(data = {}) {
        return axios.post(api.getTrainingByTrainingId, data);
    },
    /**
     * 根据实训课程id查询实训模型项目  @data "curriculumId": "课程id" ;
     */
    getTagTrainingByCurriculumId(data = {}) {
        return axios.post(api.getTagTrainingByCurriculumId, data);
    },

    /**
     * 创建实训项目  @data {
        curriculumId: '课程id',
        trainingName: '课程名称',
        trainingContent: '课程详情',
        type: '实训类型',
        editorType: '编辑器类型',
        quoteTrainingId: '引用实训id',
      }
     */
    insertTraining(data = {}) {
        return axios.post(api.insertTraining, data);
    },
    /**
     * 复制实训项目  @data {trainingId: "实训id"}
     */
    copyTraining(data = {}) {
        return axios.post(api.copyTraining, data);
    },
    /**
     * 修改实训项目  @data
     */
    updateTraining(data = {}) {
        return axios.post(api.updateTraining, data);
    },
    /**
     * 删除实训项目  @data
     */
    deleteTraining(data = {}) {
        return axios.post(api.deleteTraining, data);
    },
    /**
     * 发布/撤回发布实训项目
     *  @data
     * status 实训项目状态：0为未提交；1为已提交未发布；2为已发布；3为发布后撤回
     * trainingId实训id
     */
    releaseTraining(data = {}) {
        return axios.post(api.releaseTraining, data);
    },
    /**
     * 查询实训项目被引用的实训模型  @data { trainingId: "实训id"}
     */
    getQuoteCountByTrainingId(data = {}) {
        return axios.post(api.getQuoteCountByTrainingId, data);
    },

    /**
     * 上传实训任务书  @data taskUrl实训任务书地址 trainingId实训id
     */
    uploadTrainingTask(data = {}) {
        return axios.post(api.uploadTrainingTask, data);
    },
    /**
     * 上传实训指导书  @data guidanceUrl 实训指导书地址;  trainingId实训id
     */
    uploadTrainingGuidance(data = {}) {
        return axios.post(api.uploadTrainingGuidance, data);
    },
    /**
     * 删除实训任务书  @data taskUrl实训任务书地址 trainingId实训id
     */
    deleteTrainingTask(data = {}) {
        return axios.post(api.deleteTrainingTask, data);
    },
    /**
     * 删除实训指导书  @data taskUrl实训任务书地址 trainingId实训id
     */
    deleteTrainingGuidance(data = {}) {
        return axios.post(api.deleteTrainingGuidance, data);
    },
    /**
     * 学生查询其它项目列表数据  @data curriculumId 课程id  pageNum pageSize trainingId
     */
    getOtherTrainingByCurriculumId(data = {}) {
        return axios.post(api.getOtherTrainingByCurriculumId, data);
    },
    /**
     * 获取项目解法  @data  trainingId
     */
    getProjectExplanation(data = {}) {
        return axios.post(api.getProjectExplanation, data);
    },
    /**
     * 获取项目题面  @data  trainingId
     */
    getProjectQuestion(data = {}) {
        return axios.post(api.getProjectQuestion, data);
    },
    /**
     * 学生发布项目解法  @data  trainingId
     */
    releaseProjectExplanation(data = {}) {
        return axios.post(api.releaseProjectExplanation, data);
    },
      /**
     查询实训项目编辑方式 @data  dictTypeCode:'EditorType' 字典类型编码
     */
    getTrainingType(data = {}) {
        return axios.post(api.getTrainingType, data);
    },

    /**
     * 根据租户查询实训项目类型  @data {"tenantId": 租户Id, "dictTypeCode": "ItemType(字典编码)"}
     */
    getProjectType(data = {}) {
        return axios.post(api.getProjectType, data);
    },
};